export default "__VITE_ASSET__BYqmiLbZ__"